import { useEffect, useRef, useState } from "react";
import { ManufacturersViewModel } from "../../../viewmodels/setup/manufacturers/ManufacturersViewModel";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import { withRouter } from "../../../shared/utility";
import SlideOver from "../../../components/slideOver/SlideOver";
import EmptyModal from "../../../components/modals/EmptyModal";
import {
  SetupActions,
  SetupPage,
  SetupTable,
  SetupTd,
} from "../../../components/setup/SetupPage";
import AuditActionLink from "../../../components/audit/AuditActionLink";
import { auditHistoriesSetupAction } from "../../../components/audit/auditEntityConfig";

function Manufacturers(props) {
  const { addSnackbar, logout } = props;
  const [initialLoading, setInitialLoading] = useState(true);
  const {
    emptyModal,
    setEmptyModelOpen,
    getManufacturers,
    getTaxRatesForDropdown,
    loading,
    manufacturers,
    openAddManufacturerSlideOver,
    setSlideOver,
    slideOver,
    fetchManufacturerDetails,
    askDeleteManufacturer,
  } = ManufacturersViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    Promise.all([
      getManufacturers(null, currentPage),
      getTaxRatesForDropdown(),
    ]).finally(() => setInitialLoading(false));
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const searchRef = useRef();

  const handleSearch = () => {
    getManufacturers(searchRef.current.value, currentPage);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getManufacturers(searchRef.current.value, currentPage);
  };

  return (
    <div>
      <SetupPage
        title="Suppliers"
        description="Manage suppliers used across purchased items."
        searchPlaceholder="Search suppliers"
        searchRef={searchRef}
        onSearch={handleSearch}
        actions={[
          {
            label: "Add Suppliers",
            onClick: openAddManufacturerSlideOver,
            disabled: initialLoading,
          },
          auditHistoriesSetupAction("manufacturer"),
        ]}
        loading={loading || initialLoading}
        tableColumns={["Name"]}
        totalRecords={manufacturers.total}
        first={first}
        rows={rows}
        onPageChange={handlePagination}
      >
        <SetupTable columns={["Name"]} emptyText="No manufacturers found.">
          {manufacturers.data?.map((item, index) => (
            <tr key={item.id} className="transition hover:bg-[#F6F8FB]/80">
              <SetupTd muted={false}>{item.name}</SetupTd>
              <SetupActions>
                <button
                  type="button"
                  onClick={() => fetchManufacturerDetails(item, index)}
                  className="inline-flex min-w-[68px] justify-center rounded-lg border border-[#E2E8F0] bg-white px-3 py-1.5 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
                >
                  Edit
                </button>
                <AuditActionLink
                  slug="manufacturer"
                  id={item.id}
                  name={item.name}
                  className="ml-2"
                />
                <button
                  type="button"
                  onClick={() => askDeleteManufacturer(item, index)}
                  className="ml-2 inline-flex min-w-[68px] justify-center rounded-lg border border-[#FECACA] bg-white px-3 py-1.5 text-sm font-semibold text-[#DC2626] shadow-sm transition hover:border-[#FCA5A5] hover:bg-[#FEF2F2]"
                >
                  Delete
                </button>
              </SetupActions>
            </tr>
          ))}
        </SetupTable>
      </SetupPage>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Manufacturers),
);
